import React, { useState } from 'react';
import { useBrand } from '../context/BrandContext';

const ComingSoonPage = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const brand = useBrand();

  const handleSubmit = (e) => {
    e.preventDefault();
    // For now, just show success - can integrate with email service later
    setSubmitted(true);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-indigo-900 flex items-center justify-center p-4">
      <div className="max-w-xl w-full text-center space-y-8">
        {/* Logo */}
        <div className="flex items-center justify-center gap-3">
          <div className="relative w-12 h-12">
            <div className="absolute inset-0 bg-gradient-to-br from-blue-400 to-indigo-500 rounded-xl rotate-3 shadow-lg"></div>
            <div className="absolute inset-0 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center">
              <svg className="w-7 h-7 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2L2 7l10 5 10-5-10-5z" />
                <path d="M2 17l10 5 10-5" />
                <path d="M2 12l10 5 10-5" />
              </svg>
            </div>
          </div>
          <div className="flex flex-col text-left">
            <h1 className="text-3xl font-bold text-white">
              {brand?.nameParts?.main || 'Merch'}<span className="text-blue-400">{brand?.nameParts?.accent || 'Like'}</span>
            </h1>
            <span className="text-xs font-medium text-blue-300/70 -mt-0.5">{brand?.tagline || 'Merch like magic.'}</span>
          </div>
        </div>

        {/* Main Content */}
        <div className="space-y-4">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-500/20 border border-blue-400/30 rounded-full text-sm font-medium text-blue-300">
            <span className="w-2 h-2 bg-blue-400 rounded-full animate-pulse"></span>
            Coming Soon
          </div>

          <h2 className="text-4xl sm:text-5xl font-extrabold text-white leading-tight">
            Create custom merch<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400">
              powered by AI
            </span>
          </h2>

          <p className="text-lg text-slate-300 max-w-md mx-auto">
            Upload your artwork, let AI optimize it, and create premium merchandise in seconds. We're launching soon.
          </p>
        </div>

        {/* Email Signup */}
        <div className="max-w-md mx-auto">
          {!submitted ? (
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                className="flex-1 px-4 py-3 bg-white/10 border border-white/20 rounded-xl text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
              <button
                type="submit"
                className="px-6 py-3 bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white font-semibold rounded-xl transition-all shadow-lg hover:shadow-xl"
              >
                Notify Me
              </button>
            </form>
          ) : (
            <div className="p-4 bg-green-500/20 border border-green-400/30 rounded-xl text-green-300">
              Thanks! We'll notify you when we launch.
            </div>
          )}
        </div>

        {/* Features Preview */}
        <div className="grid grid-cols-3 gap-4 pt-8 border-t border-white/10">
          <div className="text-center">
            <div className="w-10 h-10 bg-blue-500/20 rounded-lg flex items-center justify-center mx-auto mb-2">
              <svg className="w-5 h-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
            <p className="text-sm text-slate-300 font-medium">AI Image Gen</p>
          </div>
          <div className="text-center">
            <div className="w-10 h-10 bg-indigo-500/20 rounded-lg flex items-center justify-center mx-auto mb-2">
              <svg className="w-5 h-5 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
              </svg>
            </div>
            <p className="text-sm text-slate-300 font-medium">50+ Products</p>
          </div>
          <div className="text-center">
            <div className="w-10 h-10 bg-purple-500/20 rounded-lg flex items-center justify-center mx-auto mb-2">
              <svg className="w-5 h-5 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <p className="text-sm text-slate-300 font-medium">Instant Preview</p>
          </div>
        </div>

        {/* Footer */}
        <p className="text-sm text-slate-500">
          © {brand?.legal?.copyrightYear || '2025'} {brand?.legal?.copyrightText || brand?.name || 'MerchLike'}. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default ComingSoonPage;
